<ngx-spinner bdColor="rgba(51,51,51,0.55)"
             size="medium"
             color="#fff"
             type="line-spin-clockwise-fade"
             [fullScreen]="false">
    <p class="loading">{{'general.loading' | translate}}...</p>
</ngx-spinner>
<div class="col-12" id="account">
    <h2 class="page-title" tabindex="0">{{'account.edit-account' | translate}}</h2>

    <xng-breadcrumb separator=" > ">
        <ng-container *xngBreadcrumbItem="let breadcrumb">
            <span *ngIf="breadcrumb">{{ 'account.' + breadcrumb | translate }}</span>
        </ng-container>
    </xng-breadcrumb>
    <div class="card border-top mt-2">
        <div class="card-body">
            <div class="col-12">
                <h4 class="page-title mt-0">{{'account.org_info' | translate}}</h4>
                <hr>
                <form class="w-100" [formGroup]="editAccountForm" (ngSubmit)="editAccount()" name="form"> 
                    <div class="row" >
                        <div class="col-sm-12 col-md-6">
                            <label for="name" class="text-left w-100">{{'account.name' | translate}}<span class="error">*</span></label>
                            <input id="name" type="text" class="form-control" maxlength="45" formControlName = "name"
                            [ngClass]="{ 'is-valid': name['valid'], 'is-invalid': name['invalid'] }"  />
                            <ng-container *ngIf="editAccountForm.get('name').invalid && (editAccountForm.get('name').touched || editAccountForm.get('name').dirty)">
                                <div *ngIf="editAccountForm.get('name').hasError('required')" class="error ta-left">
                                    {{'general.required_field' | translate}}
                                </div>
                                <div *ngIf="editAccountForm.get('name').hasError('pattern')" class="error ta-left">
                                    {{'general.required_field' | translate}}
                                </div>
                            </ng-container>
                        </div>
                        <div class="col-sm-12 col-md-3">
                            <label for="phoneNumber" class="text-left w-100">{{'account.phone' | translate}}<span class="error">*</span></label>
                            <input id="phoneNumber" type="text" class="form-control" maxlength="20" formControlName = "phoneNumber"
                            [ngClass]="{ 'is-valid': phoneNumber['valid'], 'is-invalid': phoneNumber['invalid'] }"  />
                            <ng-container *ngIf="editAccountForm.get('phoneNumber').invalid && (editAccountForm.get('phoneNumber').touched || editAccountForm.get('phoneNumber').dirty)">
                                <div *ngIf="editAccountForm.get('phoneNumber').hasError('required')" class="error ta-left">
                                    {{'general.required_field' | translate}}
                                </div>
                                <div *ngIf="editAccountForm.get('phoneNumber').hasError('pattern')" class="error ta-left">
                                    {{'error.org_number' | translate}}
                                </div>
                            </ng-container>
                        </div>
                        <div class="col-sm-12 col-md-3">
                            <label for="extPhoneNumber" class="text-left w-100">{{'account.ext_phone' | translate}}</label>
                            <input id="extPhoneNumber" type="text" class="form-control" maxlength="8" formControlName = "extPhoneNumber"
                            [ngClass]="{ 'is-valid': extPhoneNumber['valid'], 'is-invalid': extPhoneNumber['invalid'] }"  />
                            <ng-container *ngIf="editAccountForm.get('extPhoneNumber').invalid && (editAccountForm.get('extPhoneNumber').touched || editAccountForm.get('extPhoneNumber').dirty)">
                                <div *ngIf="editAccountForm.get('extPhoneNumber').hasError('pattern')" class="error ta-left">
                                    {{'error.org_ext_number' | translate}}
                                </div>
                            </ng-container>
                        </div>

                    </div>
                    <div class="row mt-2">
                        <div class="col-sm-12 col-md-6">
                            <label for="address" class="text-left w-100">{{'user.address' | translate}}</label>
                            <input id="address" type="text" class="form-control" maxlength="250" formControlName = "address"
                            [ngClass]="{ 'is-valid': address['valid'], 'is-invalid': address['invalid'] }"  />
                            <ng-container *ngIf="editAccountForm.get('address').invalid && (editAccountForm.get('address').touched || editAccountForm.get('address').dirty)">
                                <div *ngIf="editAccountForm.get('address').hasError('pattern')" class="error ta-left">
                                    {{'error.address' | translate}}
                                </div>
                            </ng-container>
                        </div>
                        <div class="col-sm-12 col-md-6">
                            <label for="city" class="text-left w-100">{{'user.city' | translate}}</label>
                            <input id="city" type="text" class="form-control" maxlength="50" formControlName = "city"
                            [ngClass]="{ 'is-valid': city['valid'], 'is-invalid': city['invalid'] }"  />
                            <ng-container *ngIf="editAccountForm.get('city').invalid && (editAccountForm.get('city').touched || editAccountForm.get('city').dirty)">
                                <div *ngIf="editAccountForm.get('city').hasError('pattern')" class="error ta-left">
                                    {{'error.address' | translate}}
                                </div>
                            </ng-container>
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-sm-12 col-md-6">
                            <label for="state" class="text-left w-100">{{'user.state' | translate}}</label>
                            <input id="state" type="text" class="form-control" maxlength="50" formControlName = "state"
                            [ngClass]="{ 'is-valid': state['valid'], 'is-invalid': state['invalid'] }"  />
                            <ng-container *ngIf="editAccountForm.get('state').invalid && (editAccountForm.get('state').touched || editAccountForm.get('state').dirty)">
                                <div *ngIf="editAccountForm.get('state').hasError('pattern')" class="error ta-left">
                                    {{'error.address' | translate}}
                                </div>
                            </ng-container>
                        </div>
                        <div class="col-sm-12 col-md-6">
                            <label for="country" class="text-left w-100">{{'user.country' | translate}}</label>
                            <input id="country" type="text" class="form-control" maxlength="60" formControlName = "country"
                            [ngClass]="{ 'is-valid': country['valid'], 'is-invalid': country['invalid'] }"  />
                            <ng-container *ngIf="editAccountForm.get('country').invalid && (editAccountForm.get('country').touched || editAccountForm.get('country').dirty)">
                                <div *ngIf="editAccountForm.get('country').hasError('pattern')" class="error ta-left">
                                    {{'error.address' | translate}}
                                </div>
                            </ng-container>
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-sm-12 col-md-6">
                            <label for="zip" class="text-left w-100">{{'user.zip_code' | translate}}</label>
                            <input id="zip" type="text" class="form-control" maxlength="5" formControlName = "zip"
                            [ngClass]="{ 'is-valid': zip['valid'], 'is-invalid': zip['invalid'] }"  />
                            <ng-container *ngIf="editAccountForm.get('zip').invalid && (editAccountForm.get('zip').touched || editAccountForm.get('zip').dirty)">
                                <div *ngIf="editAccountForm.get('zip').hasError('pattern')" class="error ta-left">
                                    {{'error.numbers_only' | translate}}
                                </div>
                            </ng-container>
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-12 text-right">
                            <button type="button" (click)="cancelEdit()"
                                class="btn btn-red btn-h-red mt-1 ml-2 mb-0 mr-2">
                                {{'general.cancel' | translate}}
                            </button>
                            <input type="submit" class="btn btn-green btn-h-green mt-1 ml-2 mb-0 mr-0" title="{{'general.update' | translate}}" 
                                value="{{'general.update' | translate}}">
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
